import { required, email, minLength, maxLength, helpers } from 'vuelidate/lib/validators'
const phoneCheck = helpers.regex('phoneCheck', /^\+\d{1,18}$/)
const numCheck = helpers.regex('numCheck', /^\d*$/)
const requiredMsg = 'Обязательное поле'
const numOnlyMsg = 'Только цифры'
const getMinLengthMsg = (num) => `Минимальное количество символов ${num}`
const getMaxLengthMsg = (num) => `Максимальное количество символов ${num}`
export default (ctx) => {
  return {
    orgType: {
      required: { validator: required, message: requiredMsg },
      minLength: { validator: minLength(2), message: getMinLengthMsg(2) }
    },
    title: {
      required: { validator: required, message: requiredMsg },
      minLength: { validator: minLength(2), message: getMinLengthMsg(2) }
    },
    name: {
      required: { validator: required, message: requiredMsg },
      minLength: { validator: minLength(1), message: getMinLengthMsg(1) }
    },
    surname: {
      required: { validator: required, message: requiredMsg },
      minLength: { validator: minLength(1), message: getMinLengthMsg(1) }
    },
    position: {
      minLength: { validator: minLength(2), message: getMinLengthMsg(2) }
    },
    phone: {
      required: { validator: required, message: requiredMsg },
      phoneCheck: { validator: phoneCheck, message: 'Неверный формат номера' }
    },
    inn: {
      required: { validator: required, message: requiredMsg },
      numCheck: { validator: numCheck, message: numOnlyMsg },
      minLength: { validator: minLength(10), message: getMinLengthMsg(10) },
      maxLength: { validator: maxLength(12), message: getMaxLengthMsg(12) }
    },
    email: {
      required: { validator: required, message: requiredMsg },
      email: { validator: email, message: 'Неверный формат email адреса' }
    },
    ogrn: {
      numCheck: { validator: numCheck, message: numOnlyMsg },
      maxLength: { validator: maxLength(15), message: getMaxLengthMsg(15) }
    },
    checkingAcc: {
      numCheck: { validator: numCheck, message: numOnlyMsg },
      maxLength: { validator: maxLength(20), message: getMaxLengthMsg(20) }
    },
    bic: {
      numCheck: { validator: numCheck, message: numOnlyMsg },
      maxLength: { validator: maxLength(9), message: getMaxLengthMsg(9) }
    }
  }
}
